import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import HeroCarousel from '../../../Components/common/HeroSection';
import {
  getIndicesRequest,
  getIndicesSuccess,
  getMapPreferenceRequest,
} from '../../../redux/actions';
import { AXIOS_INSTANCE } from '../../../redux/api/apiEndPoint';
import { getDmsPillarsRequest } from '../../../redux/home/homeActions';
import Footer from '../Footer';
import CountrySpecificContent from './CountrySpecificContent';
// import DroughtAlerts from './DroughtAlerts';
import DroughtInsights from './DroughtInsights';

function CountrySpecificTool() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [cordinateAndZoom, setCordinateAndZoom] = useState({
    cordinates: [23.4073, 79.446],
    zoom: 4,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [countryData, setCountryData] = useState({});
  const [boundariesData, setBoundariesData] = useState([]);
  const [geoJsonData, setGeoJsonData] = useState([]);

  const urlParams = new URLSearchParams(window.location.search);
  const selectedCountry = urlParams.get('Country');

  const { DroughtIndicesData, LandingPageData, boundries } = useSelector(state => ({
    DroughtIndicesData: state.AccessKey.getIndicesData,
    LandingPageData: state.Home,
    boundries: state.Map_Preference,
  }));

  useEffect(() => {
    return () => {
      dispatch(getIndicesSuccess({}));
    };
  }, []);

  useEffect(() => {
    if (LandingPageData.getDmsPillarsData) {
      const { result } = LandingPageData.getDmsPillarsData.data;
      const filteredData = result.filter(
        pillar => pillar.pillar_type === 'monitoring_early_warning',
      );
      const data = filteredData?.[0]?.values?.find(each => each?.country_slug === selectedCountry);
      localStorage?.setItem('countryData', JSON.stringify(data));
      setCountryData(data);
      if (data) {
        dispatch(
          getMapPreferenceRequest(
            data.country_slug === 'southasia'
              ? { region_id: 'e2f886a7-3299-4c82-af2e-987fe92fab39' }
              : { country_id: data?.country_id },
          ),
        );
      }
    }
  }, [LandingPageData.getDmsPillarsData]);

  useEffect(() => {
    if (!_.isEmpty(countryData)) {
      setCordinateAndZoom(prev => {
        return {
          ...prev,
          cordinates: [countryData?.latitude, countryData?.longitude],
          zoom: countryData?.country_slug === 'srilanka' ? 7 : 4,
        };
      });
      dispatch(
        getIndicesRequest({
          requestObj: {
            type: 'country',
            type_id:
              countryData?.country_name !== 'South Asia'
                ? countryData?.country_id
                : 'e2f886a7-3299-4c82-af2e-987fe92fab39', // ID of India
          },
          module: 'drought-monitor',
        }),
      );
    }
  }, [countryData?.id]);

  useEffect(() => {
    window.scrollTo(0, 0);

    dispatch(getDmsPillarsRequest({}));
  }, [dispatch]);

  // * SETTING BOUNDARIES DATA
  const firstRun = useRef(true);
  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }
    if (boundries?.mapPreferenceData) {
      setBoundariesData(boundries?.mapPreferenceData?.data?.result);
    }
  }, [boundries?.mapPreferenceData]);

  const isSecondRun = useRef(true);
  useEffect(() => {
    if (isSecondRun.current) {
      isSecondRun.current = false;
      return;
    }
    if (boundariesData && boundariesData?.length) {
      let API_URL = [];
      boundariesData?.forEach(item => {
        if (item.category === 'Admin') {
          if (item?.data && item?.data.length) {
            item.data.forEach(boundary => {
              let boundaryTypes =
                countryData?.country_slug === 'southasia'
                  ? ['country']
                  : ['country', 'states_or_provinces'];
              if (boundaryTypes.includes(boundary?.boundarytype?.slug)) {
                if (boundary?.boundary_data_url.length) {
                  let config = {
                    name: boundary?.boundarytype?.slug,
                    id: boundary?.boundarytype_id,
                    color: boundary?.boundarytype?.color?.code,
                    category: boundary?.category,
                    country_id: boundary?.country_id,
                  };
                  API_URL.push(AXIOS_INSTANCE.get(boundary?.boundary_data_url, config));
                }
              }
            });
          }
        }
      });
      Promise.all(API_URL).then(response => {
        let res = JSON.parse(JSON.stringify(response));
        if (res?.length) {
          setGeoJsonData(res);
        }
      });
    }
  }, [boundariesData]);

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1)); // Remove the "#" from the hash
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <>
      <HeroCarousel />
      <CountrySpecificContent />
      <DroughtInsights
        id="drought-insigths"
        cordinateAndZoom={cordinateAndZoom}
        countryData={countryData}
        indicesData={DroughtIndicesData || {}}
        isLoading={isLoading}
        setCordinateAndZoom={setCordinateAndZoom}
        setIsLoading={setIsLoading}
        geoJsonData={geoJsonData}
      />
      {/* Commenting because of static data */}
      {/* <DroughtAlerts id="drought-alerts" /> */}
      <Footer backgroundColor="" />
    </>
  );
}

export default CountrySpecificTool;
